import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenericList } from '../../commons/generic.responses';
import { SearchService } from '../../services/search.service';
import { endpoints } from '../../apis/endpoints';

@Component({
  selector: 'app-city-search',
  templateUrl: './city-search.component.html',
  styleUrl: './city-search.component.scss'
})
export class CitySearchComponent implements OnInit {

  @Input() idx: number;
  @Input() readMode: boolean;
  @Input() defaultValue: string = null;

  @Output() searchEvent = new EventEmitter<string>();

  searchCity: string = '';
  cities: GenericList[] = [];

  constructor(
    private _searchService: SearchService
  ) { }

  ngOnInit(): void {
    this.searchCity = this.defaultValue;
  }

  SearchCity() {
    this._searchService.SearchCatalog(this.searchCity, endpoints.SEARCH_CITY).subscribe(res => {
      this.cities = res;
    })
  }

  NotifyParent() {
    this.searchEvent.emit(this.searchCity);
  }

}
